








































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

interface RoleView {
  id: string;
  label: string;
  subtitle: string;
  icon: string;
  code: string;
  headline: string;
  intro: string;
  priority: string;
  priorityTone: string;
  needToKnow: string[];
  actions: string[];
  boundary: string;
}

interface SourceRecord {
  id: string;
  icon: string;
  tone: string;
  time: string;
  source: string;
  title: string;
  detail: string;
}

@Component
export default class AiCareDemo extends Vue {
  public activeStep = 0;
  public maxUnlockedStep = 0;
  public scenario: "standard" | "emergency" = "standard";
  public stepTransitioning = false;
  public emergencyStep = 0;
  public sourceExpanded = false;
  public acquiring = false;
  public acquiredCount = 0;
  public selectedRole = "community";
  public transcript = "";
  public recording = false;
  public structuredReady = false;
  public decision = "";
  public decisionNote = "";
  public sourceDialog = false;
  public selectedSource: SourceRecord | null = null;
  public eventTimestamp = "";
  public eventId = "";
  public emergencyEventId = "";
  private timers: number[] = [];

  public steps = [
    {
      eyebrow: "既有流程",
      short: "量測與複測",
      title: "血壓異常事件，社區依既有流程複測",
      description:
        "從既有量測規則觸發的異常通知出發，社區人員依既有流程安排休息與複測。",
    },
    {
      eyebrow: "AI 時刻",
      short: "回報與彙整",
      title: "現場回報後，AI 彙整成個管師待確認摘要",
      description:
        "社區回報通知個管師確認，AI 同步整理回報內容並取得相關服務資料。",
    },
    {
      eyebrow: "AI 時刻",
      short: "角色協作",
      title: "同一事件，轉換成不同角色的工作資訊",
      description:
        "原始事件不變，資訊焦點依社區、個管與醫事人員職責調整。",
    },
    {
      eyebrow: "個管決定",
      short: "確認服務事項",
      title: "AI 提供待確認摘要，最終服務決定由個管師確認",
      description:
        "個管師可決定持續追蹤、聯絡家屬、安排門診，或轉介醫事人員。",
    },
    {
      eyebrow: "結果回饋",
      short: "事件時間軸",
      title: "服務結果回到模組，形成完整事件時間軸",
      description:
        "從通知到執行結果皆可追溯，並清楚顯示持續追蹤或完成。",
    },
  ];

  public acquisitionSources = [
    {
      icon: "mdi-heart-pulse",
      system: "MEASUREMENT",
      title: "近期量測",
      detail: "7 日內 6 筆 · 2 筆偏高",
    },
    {
      icon: "mdi-clipboard-pulse-outline",
      system: "ASSESSMENT",
      title: "健康評估",
      detail: "3 份 · 最近更新 07/20",
    },
    {
      icon: "mdi-walk",
      system: "ACTIVITY & EDUCATION",
      title: "活動與衛教課程",
      detail: "步數下降 · 課程缺席 1 次",
    },
    {
      icon: "mdi-message-text-outline",
      system: "CARE NOTES",
      title: "關懷紀錄",
      detail: "近 30 日 4 筆文字紀錄",
    },
    {
      icon: "mdi-clipboard-clock-outline",
      system: "SERVICE ITEMS",
      title: "未完成服務事項",
      detail: "用藥確認 · 逾期 2 日",
    },
  ];

  public rawRecords: SourceRecord[] = [
    {
      id: "M-1042",
      icon: "mdi-heart-pulse",
      tone: "red",
      time: "今天 09:42",
      source: "血壓設備",
      title: "178 / 112 mmHg，脈搏 96",
      detail: "既有規則 BP-R03：高度異常",
    },
    {
      id: "M-1031",
      icon: "mdi-chart-line",
      tone: "amber",
      time: "07/25 08:51",
      source: "量測紀錄",
      title: "162 / 96 mmHg",
      detail: "7 日內第二筆偏高紀錄",
    },
    {
      id: "A-0318",
      icon: "mdi-walk",
      tone: "blue",
      time: "最近 7 日",
      source: "活動紀錄",
      title: "日均步數下降 38%",
      detail: "2,140 步／日，前週為 3,458 步／日",
    },
    {
      id: "C-0087",
      icon: "mdi-message-text-outline",
      tone: "violet",
      time: "07/23 15:10",
      source: "電話關懷",
      title: "偶爾忘記服用降壓藥",
      detail: "家屬表示近期需再次提醒",
    },
    {
      id: "S-0211",
      icon: "mdi-clipboard-clock-outline",
      tone: "green",
      time: "逾期 2 日",
      source: "服務事項",
      title: "用藥確認尚未完成",
      detail: "承辦角色：個案管理師",
    },
  ];

  public roles: RoleView[] = [
    {
      id: "community",
      label: "社區人員",
      subtitle: "現場確認",
      icon: "mdi-home-heart",
      code: "COMMUNITY",
      headline: "先確認現場狀況，依既有流程複測與回報",
      intro:
        "只需要專注在長輩當下的狀況，不需要判斷後續就醫或服務安排。",
      priority: "立即處理",
      priorityTone: "urgent",
      needToKnow: [
        "本次血壓 178/112 mmHg，休息後複測仍為 156/98 mmHg",
        "既有規則已判定需要進一步關注",
        "個管師正在等待現場回報確認",
      ],
      actions: [
        "確認長輩量測姿勢與現場狀況",
        "讓長輩坐下休息後再量測一次",
        "依既有流程回報複測結果與現場狀況，不需自行判斷送醫",
      ],
      boundary:
        "社區人員只負責現場確認、複測與回報；是否聯絡家屬、安排門診或轉介醫事人員，由個管師判斷。",
    },
    {
      id: "manager",
      label: "個案管理師",
      subtitle: "服務承接",
      icon: "mdi-account-tie-outline",
      code: "CASE MANAGER",
      headline: "整合現場回報與歷史資料，決定後續服務",
      intro:
        "聚焦複測後是否仍需要關注、家屬聯繫狀況與未完成事項，由個管師決定下一步，而非直接送醫。",
      priority: "30 分鐘內",
      priorityTone: "warning",
      needToKnow: [
        "本次與複測血壓：178/112 → 156/98 mmHg",
        "社區回報：已休息複測，自述頭暈稍緩解，家屬晚上可聯絡",
        "近 7 日已有兩筆偏高量測，活動量同步下降",
        "用藥確認事項已逾期 2 日",
      ],
      actions: [
        "檢視 AI 彙整的個管師待確認摘要",
        "決定持續追蹤、聯絡家屬、安排門診或轉介醫事人員",
        "如需轉介，補充需要專業確認的問題",
      ],
      boundary:
        "個管師是社區回報後的主要決策入口；只有在需要專業判斷時才轉介醫事人員，並非每筆異常都會送醫。",
    },
    {
      id: "hospital",
      label: "醫事人員",
      subtitle: "專業確認",
      icon: "mdi-hospital-building",
      code: "CLINICAL",
      headline: "僅接收個管師轉介或緊急事件",
      intro:
        "呈現的是已經過社區與個管確認的脈絡，而非原始的每一筆異常通知。",
      priority: "待資料補齊",
      priorityTone: "clinical",
      needToKnow: [
        "僅在個管師轉介或符合緊急條件時才會看到此事件",
        "本次與複測血壓：178/112 → 156/98 mmHg，社區已完成現場確認",
        "個管師已彙整回報內容與近期趨勢，待專業判斷後續處置",
      ],
      actions: [
        "檢視個管師轉介的待確認問題",
        "依專業判斷提供後續處置或轉介建議",
        "標記需持續監測的指標",
      ],
      boundary:
        "醫事人員做專業判斷；不會收到每一筆初次異常通知，僅處理個管師轉介或符合緊急條件的事件。",
    },
  ];

  public timeline = [
    {
      time: "09:42",
      title: "量測異常通知",
      detail: "血壓 178/112 mmHg，規則 BP-R03",
      owner: "既有系統",
      icon: "mdi-bell-alert-outline",
    },
    {
      time: "09:48",
      title: "社區複測與回報",
      detail: "休息 10 分鐘後複測 156/98 mmHg，已回報現場狀況",
      owner: "社區人員",
      icon: "mdi-home-heart",
    },
    {
      time: "09:50",
      title: "AI 彙整服務脈絡",
      detail: "整理現場回報並取得 5 類、18 筆相關資料",
      owner: "AI 模組",
      icon: "mdi-auto-fix",
    },
    {
      time: "09:53",
      title: "個管確認事件",
      detail: "檢視待確認摘要，準備決定後續處理",
      owner: "個案管理師",
      icon: "mdi-account-tie-outline",
    },
  ];

  public emergencySteps = [
    {
      eyebrow: "現場確認",
      short: "量測異常事件",
      title: "血壓異常事件，符合醫院既定緊急條件",
      description:
        "長輩出現符合醫院既定緊急條件的狀況，社區人員依既有緊急流程立即處理。",
    },
    {
      eyebrow: "結果回饋",
      short: "事件時間軸",
      title: "依既有緊急流程完成處置，事件已結案",
      description:
        "回報與處置已直接寫入時間軸，不需等待 AI 彙整或一般個管確認流程。",
    },
  ];

  public hospitalOptions = [
    "臺大醫院雲林分院斗六院區",
    "長庚紀念醫院雲林院區（麥寮）",
    "成大醫院斗六分院",
    "中國醫藥大學附設醫院北港分院",
    "天主教若瑟醫院",
  ];

  public selectedHospital = "";

  private emergencyTimelineBase = [
    {
      time: "09:42",
      title: "量測異常通知",
      detail: "血壓 196/120 mmHg，脈搏 132，規則 BP-R03",
      owner: "既有系統",
      icon: "mdi-bell-alert-outline",
    },
    {
      time: "09:44",
      title: "現場確認符合緊急條件",
      detail: "長輩意識不清，符合醫院既定緊急處理條件",
      owner: "社區人員",
      icon: "mdi-account-alert-outline",
    },
  ];

  private decisionFinalSteps: Record<
    string,
    { title: string; icon: string }
  > = {
    track: { title: "安排持續追蹤", icon: "mdi-calendar-clock-outline" },
    contact: { title: "聯絡家屬確認", icon: "mdi-phone-outline" },
    clinic: { title: "安排門診複診", icon: "mdi-hospital-box-outline" },
    refer: { title: "轉介醫事人員", icon: "mdi-account-arrow-right-outline" },
  };

  private decisionNoteDefaults: Record<string, string> = {
    track: "安排 3 日內電話關懷，觀察血壓趨勢，如持續偏高再評估。",
    contact: "已請家屬留意複測與服藥狀況，晚間再次確認長輩情形。",
    clinic: "協助安排近期門診複診，並提醒攜帶近期量測紀錄。",
    refer: "複測仍偏高且有頭暈症狀，請醫事人員協助判斷後續處置。",
  };

  get progressPercent(): number {
    return ((this.activeStep + 1) / this.steps.length) * 100;
  }

  get currentRole(): RoleView {
    return this.roles.find((role) => role.id === this.selectedRole) || this.roles[0];
  }

  get contextReady(): boolean {
    return this.acquiredCount === this.acquisitionSources.length;
  }

  get canContinue(): boolean {
    if (this.activeStep === 1) return this.contextReady;
    if (this.activeStep === 3) {
      return this.decision !== "" && this.decisionNote.trim().length > 0;
    }
    return true;
  }

  get nextButtonLabel(): string {
    const labels = [
      "進行現場回報",
      "查看角色協作資訊",
      "交由個管師確認",
      "完成並查看時間軸",
    ];
    return labels[this.activeStep] || "下一步";
  }

  get decisionLabel(): string {
    const labels: Record<string, string> = {
      track: "持續追蹤",
      contact: "聯絡家屬",
      clinic: "安排門診",
      refer: "轉介醫事人員",
    };
    return labels[this.decision] || "";
  }

  get resultTitle(): string {
    if (this.decision === "refer") return "已轉介醫事人員，等待專業確認";
    if (this.decision === "clinic") return "個管已安排門診，事件待門診結果";
    if (this.decision === "contact") return "個管已聯絡家屬，持續掌握現場狀況";
    return "個管已安排持續追蹤，事件保持關注";
  }

  get resultDescription(): string {
    if (this.decision === "refer") {
      return `個管師檢視 AI 彙整的複測與現場回報內容後，決定轉介醫事人員協助判斷。備註：${this.decisionNote}`;
    }
    if (this.decision === "clinic") {
      return `個管師已協助安排近期門診複診。備註：${this.decisionNote}`;
    }
    if (this.decision === "contact") {
      return `個管師已聯絡家屬確認長輩現況。備註：${this.decisionNote}`;
    }
    return `個管師已安排後續電話關懷追蹤。備註：${this.decisionNote}`;
  }

  get resultStatus(): string {
    if (this.decision === "refer") return "待醫事人員確認";
    if (this.decision === "clinic") return "待門診";
    return "持續追蹤";
  }

  get nextFollowUp(): string {
    if (this.decision === "refer") return "依醫事人員回覆安排";
    if (this.decision === "clinic") return "依門診時間安排";
    return "07/28 09:00";
  }

  get displayedTimeline() {
    const finalStep = this.decisionFinalSteps[this.decision];
    if (!finalStep) return this.timeline;
    const entries = [
      ...this.timeline,
      {
        time: "09:58",
        title: finalStep.title,
        detail: this.decisionNote,
        owner: "個案管理師",
        icon: finalStep.icon,
      },
    ];
    if (this.decision === "refer") {
      entries.push({
        time: "10:20",
        title: "醫事人員確認中",
        detail: "等待專業判斷回覆",
        owner: "醫事人員",
        icon: "mdi-stethoscope",
      });
    }
    return entries;
  }

  get emergencyTimeline() {
    const hospital = this.selectedHospital.trim() || "就近醫院";
    return [
      ...this.emergencyTimelineBase,
      {
        time: "09:45",
        title: "立即聯絡並協助送醫",
        detail: `依既有緊急流程聯絡家屬，協助長輩送醫至${hospital}`,
        owner: "社區人員",
        icon: "mdi-phone-alert-outline",
      },
      {
        time: "09:50",
        title: "同步留存紀錄，事件結案",
        detail: `已送醫至${hospital}，系統與醫事人員同步收到紀錄，不再進入一般個管流程`,
        owner: "協作完成",
        icon: "mdi-check-decagram",
      },
    ];
  }

  public padStep(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  created(): void {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    const hh = String(now.getHours()).padStart(2, "0");
    const mm = String(now.getMinutes()).padStart(2, "0");
    this.eventTimestamp = `${y}/${m}/${d} ${hh}:${mm}`;
    this.eventId = `HC-${y}${m}${d}-001`;
    this.emergencyEventId = `HC-${y}${m}${d}-E01`;
  }

  public openEventSources(): void {
    this.sourceExpanded = true;
    this.acquiring = true;
    this.acquiredCount = 0;
    this.acquisitionSources.forEach((_, index) => {
      const timer = window.setTimeout(() => {
        this.acquiredCount = index + 1;
        if (this.acquiredCount === this.acquisitionSources.length) {
          this.acquiring = false;
          this.maxUnlockedStep = Math.max(this.maxUnlockedStep, 2);
        }
      }, 520 * (index + 1));
      this.timers.push(timer);
    });
  }

  public simulateVoice(): void {
    this.recording = true;
    this.structuredReady = false;
    this.transcript = "";
    const chunks = [
      "林阿姨說今天有點頭暈，",
      "早上的降壓藥好像還沒吃，",
      "目前沒有胸痛，家屬晚上才會回來，",
      "我有請她先坐著休息。",
    ];
    chunks.forEach((chunk, index) => {
      const timer = window.setTimeout(() => {
        this.transcript += chunk;
        if (index === chunks.length - 1) {
          this.recording = false;
          this.structureReport();
        }
      }, 620 * (index + 1));
      this.timers.push(timer);
    });
  }

  public structureReport(): void {
    this.structuredReady = true;
  }

  public selectDecision(id: string): void {
    this.decision = id;
    this.decisionNote = this.decisionNoteDefaults[id] || "";
  }

  public openSource(sourceId: string): void {
    this.selectedSource =
      this.rawRecords.find((record) => record.id === sourceId) || null;
    this.sourceDialog = Boolean(this.selectedSource);
  }

  private maybeAutoStartReport(): void {
    if (this.activeStep === 1 && !this.transcript && !this.recording) {
      this.simulateVoice();
    }
  }

  public nextStep(): void {
    if (!this.canContinue || this.activeStep >= this.steps.length - 1) return;
    this.stepTransitioning = true;
    const timer = window.setTimeout(() => {
      this.activeStep += 1;
      this.maxUnlockedStep = Math.max(this.maxUnlockedStep, this.activeStep);
      this.stepTransitioning = false;
      this.maybeAutoStartReport();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 5000);
    this.timers.push(timer);
  }

  public previousStep(): void {
    if (this.activeStep > 0) this.activeStep -= 1;
  }

  public goToStep(index: number): void {
    if (index > this.maxUnlockedStep || index === this.activeStep) return;
    this.stepTransitioning = true;
    const timer = window.setTimeout(() => {
      this.activeStep = index;
      this.stepTransitioning = false;
      this.maybeAutoStartReport();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 5000);
    this.timers.push(timer);
  }

  public resetDemo(): void {
    this.clearTimers();
    this.activeStep = 0;
    this.maxUnlockedStep = 0;
    this.stepTransitioning = false;
    this.sourceExpanded = false;
    this.acquiring = false;
    this.acquiredCount = 0;
    this.selectedRole = "community";
    this.transcript = "";
    this.recording = false;
    this.structuredReady = false;
    this.decision = "";
    this.decisionNote = "";
    this.sourceDialog = false;
    this.selectedSource = null;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  private clearTimers(): void {
    this.timers.forEach((timer) => window.clearTimeout(timer));
    this.timers = [];
  }

  beforeDestroy(): void {
    this.clearTimers();
  }
}
